import React, { useMemo, useCallback, useContext } from 'react';
import _ from 'underscore';
import { DisplayPlusNativeAds } from '@bingads-webui-campaign-react/display-plus-native-ads';
import { ActuationGroup } from '@bingads-webui-campaign-react/actuator';
import { AttentionBeaconGroup } from '@bingads-webui-campaign-react/attention-beacon';
import { FormErrorGroup, UnmappedFormErrors } from '@bingads-webui-campaign-react/form-error';
import { ValidationGroup } from '@bingads-webui-react/validation';
import { AssetGroup } from '@bingads-webui/campaign-odata-schemas';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withRecommendationContext } from '@bingads-webui-campaign-react/perf-max-recommendation';

const DisplayPlusNativeFormInternal = (props) => {
  const {
    data,
    onDataChange,
    perfMarker,
    biddingScheme,
    instrumentation,
    scope,
    isSaving,
    isCanceling,
    errors,
    setAds,
    supportImageFitting,
  } = props;
  const i18n = useContext(I18nContext);

  const didServerReturnErrors = useMemo(() => errors && _.isArray(errors) && errors.length > 0, [errors]);

  const onValidate = useCallback((result) => {
    const dataPatch = {
      ...data,
      ...result.data,
      isValid: result.isValid,
    };

    onDataChange(dataPatch);
    setAds(dataPatch);
  }, [data, onDataChange, setAds, data]);

  return (
    <ActuationGroup actuationProps={{ isActive: didServerReturnErrors }}>
      <AttentionBeaconGroup>
        <FormErrorGroup formErrorProps={{ errors: errors || [], showAllValidationErrors: didServerReturnErrors }}>
          <ValidationGroup
            validationProps={{
              schema: AssetGroup,
              onValidate,
              data,
              i18n,
            }}
          >
            <div className="server-errors">
              <UnmappedFormErrors />
            </div>
            <DisplayPlusNativeAds
              data={{data}}
              onDataChange={onDataChange}
              setAds={setAds}
              perfMarker={perfMarker}
              biddingScheme={biddingScheme}
              instrumentation={instrumentation}
              scope={scope}
              isSaving={isSaving}
              isCanceling={isCanceling}
              supportImageFitting={supportImageFitting}
            />
          </ValidationGroup>
        </FormErrorGroup>
      </AttentionBeaconGroup>
    </ActuationGroup>
  );
};

export const DisplayPlusNativeForm = withRecommendationContext(DisplayPlusNativeFormInternal);
